import { ReactElement } from 'react';
import type { ElementType } from 'react';

import { css } from '@emotion/react';
import { OpenInNewOutlined } from '@mui/icons-material';
import { Typography, ListItemButton } from '@mui/material';
import { RouteLink } from '@scorenco/core';

type SocialItemProps = {
  url: string;
  name: string;
  Icon: (props: any) => ReactElement | null;
};

const MuiRouteLink = RouteLink as unknown as ElementType;

export const SocialItem = ({ url, name, Icon }: SocialItemProps) => {
  return (
    <ListItemButton
      component={MuiRouteLink}
      href={url}
      target="_blank"
      css={(theme) => css`
        color: ${theme.vars.palette.primary.main};
        align-items: center;
        justify-content: space-between;
      `}
    >
      <Typography
        sx={{
          textAlign: 'initial',
          textTransform: 'initial',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
        }}
        variant="body1"
      >
        <Icon sx={{ mr: 1 }} />
        {name}
      </Typography>
      <OpenInNewOutlined
        css={(theme) => css`
          color: ${theme.vars.palette.text.primary};
          font-size: 1rem;
        `}
      />
    </ListItemButton>
  );
};
